<template>
    <button
            class="c-button c-button--neutral c-product-size-toggle"
            type="button"
            @click="toggleChecked"
            :class="{'is-enabled': localItem.IsAvailable, 'is-pim-disabled': localItem.IsPIMDisabled}"
            :title="[localItem.IsPIMDisabled ? $t('product.variation_thumb.sizes.pim_disabled', {size: localItem.Size}) : '']"
    >
        {{ localItem.Size }} <br> <svgicon class="c-product-size-toggle__icon" v-if="localItem.IsAvailable" name="check"></svgicon>
    </button>
</template>

<script>
    export default {
        props: {
            item: Object,
        },
        data() {
            return {
                localItem: this.item,
            }
        },
        methods: {
            toggleChecked() {
                this.$set(this.localItem, 'IsAvailable', !this.localItem.IsAvailable);
                this.$emit('update:item', this.localItem);
                this.updateProductVariant();
            },
            updateProductVariant() {
                this.$store.dispatch('updateProductVariant', {
                    preOrderSheetId: this.$route.params.id,
                    productVariantId: this.localItem.Id,
                    body: {
                        Id: this.localItem.Id,
                        IsAvailable: this.localItem.IsAvailable
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-product-size-toggle {
        position: relative;
        font-weight: $bold;
        $width: auto;
        $height: em(70px);
        width: $width;
        height: $height;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        @include rfs($font-size-small);

        svg{
            fill: $color-success;
        }

        &:focus{
            @include focus();
        }

        &:not(.is-enabled){
            opacity:.5;
        }

        &.is-enabled{
            &:focus{
                @include focus($color: $color-success);
            }
        }

        &.is-pim-disabled{
            border: 4px solid $color-error;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/product/widgets/productSizeToggle.vue